import { Component, Input } from '@angular/core';
import { IconDirection, IconName } from 'studio-components/icon/types';
import { ButtonThemeLegacy, ButtonTypeLegacy } from '../../types';

@Component({
  selector: 'studio-button-legacy',
  templateUrl: './button-legacy.component.html',
  styleUrls: ['./button-legacy.component.scss'],
})
export class ButtonLegacyComponent {
  @Input() theme: ButtonThemeLegacy = 'primary';
  @Input() type: ButtonTypeLegacy = 'button';
  @Input() isUppercase = false;
  @Input() disabled = false;
  @Input() isIconOnly = false;
  @Input() iconLeft: IconName;
  @Input() iconRight: IconName;
  @Input() iconDirection: IconDirection;
  @Input() iconSize = 20;
}
